import { configure } from 'mobx';

const useProxiesValue = typeof window.Proxy !== 'undefined' ? 'always' : 'never';

configure({ useProxies: useProxiesValue });
